import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * As-built deep-link target (CU-86aj1c9ev D-A): `sendAgentAlert` emits push
 * links of the form `/sessions/{sessionId}` (CU-86ahjxpk2). Rather than build a
 * separate `/scan/{sessionId}` resolver, we normalize that path here to the
 * canonical `/sessions?focus={sessionId}` — one render path, focus handled by
 * the parent route. Authorization happens at the resolver/callable, not here.
 */
export const Route = createFileRoute('/_authenticated/sessions/$sessionId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/sessions',
      search: { focus: params.sessionId },
      replace: true,
    });
  },
});
